import React from 'react';
import VideoViewer from './video-viewer';
import { VIDEO_TYPE_LEGACY, VIDEO_TYPE } from './types';
import { containerClassName, sizeClassName } from './classNameStrategies';
import videoComponentWrapper from './components/VideoComponentWrapper/video-component-wrapper';
const videoRenderDescriptor = (externalVideoComponent)=>({
        component: externalVideoComponent ? videoComponentWrapper(externalVideoComponent) : VideoViewer,
        classNameStrategies: {
            size: sizeClassName,
            container: containerClassName
        }
    });
export function typeMapper(externalVideoComponent) {
    return ()=>({
            [VIDEO_TYPE_LEGACY]: videoRenderDescriptor(externalVideoComponent),
            [VIDEO_TYPE]: videoRenderDescriptor(externalVideoComponent)
        });
}
